import Reflux from "reflux";

// eslint-disable-next-line import/no-unresolved
import { CustomerSucessController } from "@talentbait/shared-components";

import logger from "../../utils/LoggerFrontend";
import i18n from "../../i18n";
import Actions from "../../Actions";

import CampaignMembersActions from "./CampaignMembers.actions";
import { mapCampaignMembers } from "./CampaignMembers.mappers";

const defaultState = {
  campaignMembers: [],
  isFetchingCampaignMembers: false,
  isUpdatingCampaignMembers: false
};

export default class CampaignMembersStore extends Reflux.Store {
  constructor(props) {
    super(props);
    this.state = defaultState;

    this.listenables = Object.assign(CampaignMembersActions);
  }

  onClear() {
    logger.log("CampaignMembersStore:onClear", "called");
    this.setState({
      campaignMembers: [],
      isFetchingCampaignMembers: false,
      isUpdatingCampaignMembers: false
    });
  }

  onUpdateCampaignMembers(campaignId, newCampaignMembers) {
    logger.log("CampaignMembersStore:onUpdateCampaignMembers", "called", {
      campaignId,
      newCampaignMembers
    });
    CustomerSucessController.send(`CampaignMembers:updated`, { campaignId, newCampaignMembers });

    this.setState({ isUpdatingCampaignMembers: true });
  }

  onUpdateCampaignMembersCompleted({ payload: campaignMembers }) {
    logger.log(
      "CampaignMembersStore:onUpdateCampaignMembersCompleted",
      "unable to update campaign members data",
      { campaignMembers }
    );
    Actions.addNotification(i18n.t("Campaign members have been changed successfully."));

    this.setState({ campaignMembers, isUpdatingCampaignMembers: false });
  }

  onUpdateCampaignMembersFailed(errorMessage) {
    logger.log(
      "error:CampaignMembersStore:onUpdateCampaignMembersFailed",
      "unable to update campaign members data",
      { errorMessage }
    );

    this.setState({ isUpdatingCampaignMembers: false });

    Actions.addNotification(
      `${i18n.t("There was an error updating the owner")}: ${errorMessage}`,
      "error",
      true
    );
  }

  onGetCampaignMembers() {
    logger.log("CampaignMembersStore:onGetCampaignMembers", "called", {});
    this.setState({ isFetchingCampaignMembers: true });
  }

  onGetCampaignMembersCompleted({ payload: campaignMembers }) {
    logger.log("CampaignMembersStore:onGetCampaignMembersCompleted", "finished", {
      campaignMembers
    });

    this.setState({
      isFetchingCampaignMembers: false,
      campaignMembers: mapCampaignMembers(campaignMembers)
    });
  }

  onGetCampaignMembersFailed(error) {
    logger.log(
      "error:CampaignMembersStore:onGetCampaignMembersFailed",
      "unable to campaign members",
      {
        error
      }
    );
    this.setState({ isFetchingCampaignMembers: false });
  }
}
